export default "__VITE_ASSET__7fdc9a56__"